import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../Shared/Layout';
import FactureFiltre from './FactureTable/FactureFiltre';
import FactureHeader from './components/FactureHeader';
import FactureTable from './FactureTable/FactureTable';
import useSelectedDomain from '../service/Hooks/useSelectedDomain';
import { getAllFacturations } from '../service/api/facturationService';
import './style/facture.css';
import CreateFactureModal from './FactureForm/CreateFacture';
import Pagination from './FactureTable/Pagination';
import FactureCount from './components/FctureCount';
import useFacturationFilters from '../service/Hooks/useFacturationFilters';

function Facture() {
  const { t } = useTranslation(['facturation', 'common']);
  const selectedDomain = useSelectedDomain();
  const { filters, updateFilters, getApiParams } = useFacturationFilters();
  
  const [facturations, setFacturations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationData, setPaginationData] = useState({
    pageNumber: 1,
    pageSize: 15,
    totalCount: 0,
    totalPages: 0
  });

  const loadFacturations = async () => {
    if (!selectedDomain?.id) return;
    
    setLoading(true);
    try {
      const apiParams = getApiParams();
      const response = await getAllFacturations(selectedDomain.id, apiParams);
      
      setFacturations(response.items || []);
      setPaginationData({
        pageNumber: response.pageNumber || 1,
        pageSize: response.pageSize || 15,
        totalCount: response.totalCount || 0,
        totalPages: response.totalPages || 0
      });
    } catch {
      // console.error('Error loading facturations:', error);
      setFacturations([]);
      setPaginationData({
        pageNumber: 1,
        pageSize: 15,
        totalCount: 0,
        totalPages: 0
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFacturations();
  }, [selectedDomain, filters]);

  const handleFilterChange = (newFilters) => {
    updateFilters(newFilters);
  };

  const handlePageChange = (newPage) => {
    updateFilters({ pageNumber: newPage });
  };

  const handlePageSizeChange = (newPageSize) => {
    updateFilters({ pageSize: newPageSize, pageNumber: 1 });
  };

  const handleRefresh = () => {
    loadFacturations();
  };

  return (
    <Layout>
      <div className="content-body default-height">
        <div className="container-fluid">
          <FactureHeader onRefresh={handleRefresh} />
          <FactureCount facturations={facturations} />
          
          <FactureFiltre 
            filters={filters} 
            onFilterChange={handleFilterChange}
            loading={loading}
            totalCount={paginationData.totalCount}
          />
          
          <FactureTable 
            facturations={facturations} 
            loading={loading}
            onRefresh={handleRefresh}
          />

          {/* Pagination */}
          {paginationData.totalCount > 0 && (
            <div className="mt-4">
              <Pagination
                currentPage={paginationData.pageNumber}
                totalPages={paginationData.totalPages}
                pageSize={paginationData.pageSize}
                totalCount={paginationData.totalCount}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
              />
            </div>
          )}

          <CreateFactureModal onSuccess={handleRefresh} />
        </div>
      </div>
    </Layout>
  );
}

export default Facture;